import { Component, EventEmitter, Input, OnInit, Output, ViewChild, } from '@angular/core';
import { CameraSource } from '@capacitor/camera';
import { UploadImageButtonComponent } from "@qid/super";
import { ModalController } from '@ionic/angular/standalone';
import { IonIcon, IonSpinner } from '@ionic/angular/standalone';
import { SexyModule } from '@qid/sexy';
import { CustomImageCropperComponent } from './custom-image-cropper.component';
import { ImageViewerService } from '../../../../components/image-viewer/image-viewer.service';

@Component({
  selector: 'id-image-picker',
  templateUrl: './id-image-picker.component.html',
  standalone: true,
  imports: [
    SexyModule,
    UploadImageButtonComponent,
    CustomImageCropperComponent,
    IonIcon,
    IonSpinner
  ],
})
export class IdImagePickerComponent implements OnInit {
  @ViewChild('uploadImageButtonComponent')
  uploadImageButtonComponent: UploadImageButtonComponent;

  @Input() title: string = 'Id';
  @Input() error: string = null;
  @Input() value: any = '';
  @Input() isProcessing: boolean = false;
  @Output() valueChange: EventEmitter<any> = new EventEmitter();

  public image = '';
  public originalImage = '';
  public isLoadingImage: boolean = false;
  public showCropper: boolean = false;

  constructor(private modalController: ModalController,
    private imageViewerService: ImageViewerService
  ) {
  }

  ngOnInit() {
    if (this.value && this.value[0] != null) {
      this.onImageLoad(this.value[0]);
    }
  }

  async openLibrary() {
    await this.pickImage(CameraSource.Photos);
  }

  async openCamera() {
    await this.pickImage(CameraSource.Camera);
  }

  private async pickImage(source: CameraSource) {
    this.isLoadingImage = true;
    try {
      await this.uploadImageButtonComponent.upload(source, this.title);
    } catch {
      // User cancelled or picker failed
    } finally {
      this.isLoadingImage = false;
    }
  }

  removeImage(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.value = null;
    this.image = null;
    this.originalImage = '';
    this.showCropper = false;
    this.valueChange.emit(this.value);
  }

  async openImagePreview() {
    if (!this.image || this.isProcessing) {
      return;
    }

    this.imageViewerService.open([this.image], false);
  }

  onImageLoad(file: any) {
    if (!file) {
      return;
    }
    // Skip cropping step - use image directly
    this.image = file.url;
    this.value = file;
    this.valueChange.emit(this.value);
    this.error = null;
  }

  onCroppedImage(croppedDataUrl: string) {
    this.image = croppedDataUrl;

    // Convert data URL back to file
    const file = this.dataURLtoFile(croppedDataUrl, new Date().getTime() + '.png');
    const url = URL.createObjectURL(file);

    this.value = { url: url, file: file };
    this.valueChange.emit(this.value);
    this.showCropper = false;
    this.originalImage = '';
  }

  onCropCancel() {
    this.showCropper = false;
    this.originalImage = '';
  }

  private dataURLtoFile(dataurl: string, filename: string): File {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

}
